import styled from '@emotion/styled';
import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';

import stepIcon from 'src/public/img/meditation-image-page.png';

import { AppState } from 'src/config/appState';
import { MusicPlayer } from 'src/modules/meditations/components/MusicPlayer';
import { StepButtons, StepButtonsProps } from 'src/modules/programs/components/StepButtons';
import { setMindfulnessExerciseCompleted } from 'src/modules/programs/cpProgram/weekOne/actions/weekOneActions';
import {
    getMindfulnessImprovementsDescriptions,
    isMindfulnessExerciseCompleted,
} from 'src/modules/programs/cpProgram/weekOne/selectors/weekOneSelectors';
import * as S from 'src/modules/programs/stepComponents/styles';
import { color } from 'src/shared/styles/variables';

const StepContent = styled.div({
    display: 'flex',
    position: 'relative',
    flexDirection: 'column',
    flexGrow: 1,
    justifyContent: 'space-between',
});

const MusicPlayerWrapper = styled.div({
    width: '100%',
    bottom: 0,
});

interface ActionsProps {
    setMindfulnessExerciseCompleted: typeof setMindfulnessExerciseCompleted;
}

interface StateProps {
    mindfulnessImprovementsDescriptions: string[];
    isExerciseCompleted: boolean;
}

type Props = StepButtonsProps & StateProps & ActionsProps & WithTranslation;

export class MindfulnessOfEmotionsExerciseStepContainer extends React.Component<Props> {
    public render(): JSX.Element {
        const {
            goToNextStep,
            goToPreviousStep,
            isExerciseCompleted,

            t,
        } = this.props;

        return (
            <>
                <StepContent>
                    <S.ContentRow>
                        <S.ContentColumn md={14}>
                            <S.StepHeading small>
                                {t('week-4.mindfulness-of-emotions-exercise.heading')}
                            </S.StepHeading>
                            <S.StepHeading>
                                {t('week-4.mindfulness-of-emotions-exercise.title')}
                            </S.StepHeading>
                            <S.StepDescription>
                                {t('week-4.mindfulness-of-emotions-exercise.description')}
                            </S.StepDescription>
                        </S.ContentColumn>
                        <S.ContentColumn md={10}>
                            <S.StepIcon iconUrl={stepIcon} />
                        </S.ContentColumn>
                    </S.ContentRow>

                    <MusicPlayerWrapper>
                        <MusicPlayer
                            track="https://assets.ctfassets.net/a9kub91sykpy/6suugKKRMWQwkCECKIIQU8/a9c99949a06ef07762965369ef6ea7aa/Meditation_for_Beginners_-_3_minute.mp3" // TODO: move to s3
                            color={color.scooter}
                            onTrackEnd={this.props.setMindfulnessExerciseCompleted}
                        />
                    </MusicPlayerWrapper>
                </StepContent>
                <StepButtons
                    onPreviousClick={goToPreviousStep}
                    onNextClick={goToNextStep}
                    nextDisabled={!isExerciseCompleted}
                    hasNextStep
                />
            </>
        );
    }
}

const mapStateToProps = (state: AppState) => ({
    mindfulnessImprovementsDescriptions: getMindfulnessImprovementsDescriptions(state),
    isExerciseCompleted: isMindfulnessExerciseCompleted(state),
});

export const MindfulnessOfEmotionsExerciseStep = withTranslation('cbt')(
    connect(mapStateToProps, {
        setMindfulnessExerciseCompleted,
    })(MindfulnessOfEmotionsExerciseStepContainer),
);
